import { combineReducers } from "redux";
import { firestoreReducer } from "redux-firestore";
import { firebaseReducer } from "react-redux-firebase";

import authReducer from "./authReducer";
import projectReducer from "./projectReducer";
import resumeReducer from "./resumeReducer";

const rootReducer = combineReducers({
  auth: authReducer,
  project: projectReducer,
  resume: resumeReducer,
  firestore: firestoreReducer,
  firebase: firebaseReducer
});

export default rootReducer;
